import styled from 'styled-components';

export default styled.div.attrs({ className: 'outer' })`
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  justify-self: center;
  align-self: center;
  border: 1px solid #b0bdd2;
  display: grid;
`;
